// Phase-3 multi-model: modelResponses/activeModel only ever live in React state
// today (the backend has no concept of per-model answers), so a full page
// refresh wipes them with nothing to restore from. This is a best-effort,
// client-only cache keyed by message_id so newly-asked questions keep their
// dropdown across a refresh. Never let a storage failure (quota, private
// browsing, etc.) break the actual chat flow — every operation here fails
// silently.

const STORAGE_KEY = "phase3_modelResponses";
const MAX_ENTRIES = 200;

const readAll = () => {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}");
  } catch {
    return {};
  }
};

const writeAll = (all) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(all));
  } catch {
    // best-effort cache only — never throw into the caller
  }
};

export const saveModelResponsePatch = (messageId, modelValue, patch) => {
  if (!messageId) return;
  const all = readAll();
  const entry = all[messageId] || { modelResponses: {}, activeModel: null };
  entry.modelResponses = {
    ...entry.modelResponses,
    [modelValue]: { ...entry.modelResponses[modelValue], ...patch },
  };
  if (!entry.activeModel && patch.status === "done") {
    entry.activeModel = modelValue;
  }
  all[messageId] = entry;

  // Cap growth so this doesn't accumulate forever across a long-lived session.
  const keys = Object.keys(all);
  if (keys.length > MAX_ENTRIES) {
    delete all[keys[0]];
  }

  writeAll(all);
};

export const loadModelResponse = (messageId) => {
  if (!messageId) return undefined;
  return readAll()[messageId];
};

// Settings page "Clear cache" action — wipes this client-side cache so a
// user can force a clean slate (e.g. after noticing stale/wrong dropdown
// data) without needing to clear their whole browser storage.
export const clearAllModelResponses = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // best-effort cache only — never throw into the caller
  }
};
